import React, { useState, useEffect } from 'react';
import { Modal, Select, Button, message, Form,Row,Col,Typography } from 'antd';
import http from '@/utils/http';
import api from '@/utils/api';
import {FileZipOutlined,} from "@ant-design/icons";
const ExportTxtModal = ({ visible, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [dateRanges, setDateRanges] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [form] = Form.useForm();

  // 获取日期范围数据
  const fetchDateRanges = async () => {
    setLoading(true);
    try {
      const response = await http.get(api.getDateRanges);
      if (response?.code === '1') {
        const data = response.data || [];
        setDateRanges(data);
        // 默认选中第一个
        if (data.length > 0) {
          form.setFieldsValue({ dateRange: data[0] });
        }
      } else {
        message.error(response?.msg );
      }
    } catch (error) {

      message.error('Failed to get date ranges, please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) {
      fetchDateRanges();
    } else {
      form.resetFields();
    }
  }, [visible]);

  // 下载文件
const downloadFile = (url, fileName) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || 'export.zip'; 
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  // 处理导出
  const handleExport = async () => {
    try {
      const values = await form.validateFields();
      const selectedDateRange = values.dateRange;
      
      setExportLoading(true);
      
      const response = await http.post(api.getShowStatistics, {
        dateRange: selectedDateRange
      });
      
      if (response?.code === '1') {
        const fileUrl = response.data;
        if (fileUrl) {
          message.success('Export successful, downloading...');
          downloadFile(fileUrl);
          // 延迟关闭弹窗，让下载开始
          setTimeout(() => {
            onCancel();
            form.resetFields();
          }, 500);
        } else {
          message.error('No file URL returned');
        }
      } else {
        message.error(response?.msg || 'Export failed');
      }
    } catch (error) {
      message.error(error?.response?.data?.msg || error?.msg || 'Export failed, please try again');
    } finally {
      setExportLoading(false);
    }
  };

  // 处理取消
  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
  <Modal
  title={
    <Row justify="start" align="middle" className="model_title">
      <Col>
        <FileZipOutlined className="model_title_mr10" style={{ color: '#3c8dbc' }} />
      </Col>
      <Col>
        <Typography.Title level={4} className="mg">
          EXPORT TXT
        </Typography.Title>
      </Col>
    </Row>
  }
  open={visible}
  onCancel={handleCancel}
  maskClosable={false}
  width="30%"
  centered
  footer={
    <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
      <Button onClick={handleCancel} disabled={exportLoading}>
        Cancel
      </Button>
      <Button
        type="primary"
        loading={exportLoading}
        onClick={handleExport}
      >
        Export
      </Button>
    </div>
  }
  styles={{
    body: {
      minHeight: '15vh',     
      maxHeight: '15vh',  
    }
  }}
>
  <div className="model_top" style={{ width: "100%" }}></div>
  <Form
    form={form}
    layout="horizontal"
    style={{ padding: '20px 0' }}
    labelCol={{ span: 6, offset: 3 }}
    wrapperCol={{ span: 12 }}
    labelAlign="left"
  >
    <Form.Item
      label="Select Date Range"
      name="dateRange"
      rules={[{ required: true, message: 'Please select a date range' }]}
    >
      <Select
        placeholder="Please select a date range"
        loading={loading}
        options={dateRanges.map((item) => ({
          label: item,
          value: item,
        }))}
      />
    </Form.Item>
  </Form>
</Modal>
  );
};

export default ExportTxtModal;